/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Change_Previous_BalanceInputs */

const en_plan_change_previous_balance = /** @type {(inputs: Plan_Change_Previous_BalanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previous balance`)
};

const es_plan_change_previous_balance = /** @type {(inputs: Plan_Change_Previous_BalanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saldo pendiente anterior`)
};

/**
* | output |
* | --- |
* | "Previous balance" |
*
* @param {Plan_Change_Previous_BalanceInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_change_previous_balance = /** @type {((inputs?: Plan_Change_Previous_BalanceInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Change_Previous_BalanceInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_change_previous_balance(inputs)
	return en_plan_change_previous_balance(inputs)
});